import Bugsnag from '@bugsnag/js'

import { ENV } from './env'

// errors are reported from staging and production builds only
if (ENV.target !== 'dev') {
  Bugsnag.start({
    apiKey: ENV.bugsnag_token,
    releaseStage: ENV.target === 'prod' ? 'production' : 'staging'
  })
}

export default Bugsnag
